/**
 * Central company / legal identity.
 *
 * Single source of truth for the legal entity behind the FixControl brand:
 * trade name, registered company, Chamber of Commerce / VAT numbers, address
 * and the public contact inboxes. Anything that needs to render these facts
 * — the contact page, the marketing footer legal line, JSON-LD structured
 * data — imports from here so KvK/BTW/address/email are never duplicated (and
 * can never drift) across loose components.
 *
 * Dependency-free and side-effect-free so it can be imported from server
 * components, client components, route handlers and the SEO smoke test alike.
 *
 * FixControl is the brand; FixControl B.V. is the legal entity it trades
 * under — disclosed for transparency, not positioned as the product.
 *
 * Until the KvK registration numbers arrive, the fields below are null and
 * every render site must skip its KvK/BTW line rather than print an empty
 * value. When the numbers arrive: fill them in here — nothing else should
 * need to change.
 */
export const COMPANY = {
  brandName: "FixControl",
  tradeName: "FixControl",
  legalName: "FixControl B.V.",
  legalForm: "Besloten Vennootschap",
  chamberOfCommerceNumber: null as string | null,
  establishmentNumber: null as string | null,
  vatId: null as string | null,
  publicEmail: "contact@fixcontrol.ai",
  founderEmail: "alexander@fixcontrol.ai",
  website: "https://fixcontrol.ai",
  address: {
    street: "Italiaanse Zeedijk 122 C",
    postalCode: "1621 AK",
    city: "Hoorn",
    country: "Nederland",
    countryCode: "NL",
  },
} as const;
